export default __webpack_public_path__ + "static/media/football.18a59e24.png";